import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'

interface ModalConfirmarBorrarSeleccionProps {
    show: boolean
    setShow: (show: boolean) => void
    setAgregarSeleccionados: (seleccionados: any[]) => void

}

const ModalConfirmarBorrarSeleccion = ({
    show,
    setShow,
    setAgregarSeleccionados
}: ModalConfirmarBorrarSeleccionProps) => {
    return (
        <Modal show={show} centered style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}>
            <Modal.Header closeButton={false} className="modal-header-danger" >
                <Modal.Title style={{ color: 'white', fontWeight: 'bold' }}>Confirmar Borrar Selección</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{display:'flex', flexDirection:'column', alignItems: 'center'}}>
                <FontAwesomeIcon icon={faExclamationTriangle} color='red' size='3x' />
                <p style={{ fontSize: 15, fontWeight: 'bold', textAlign: 'center', marginTop: 10 }}>¿Está seguro de que desea borrar todos los elementos seleccionados?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => {
                    setAgregarSeleccionados([])
                    setShow(false)
                }}>
                    Aceptar
                </Button>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfirmarBorrarSeleccion
